export const chartTooltipMap = {
    // Mapeamento baseado em opt.chart (traduzido) para tooltipKey
    
    // Português
    "Status dos Veículos": "DASHBOARD_CHARTS_VEHICLE_STATUS",
    "Ranking de Motoristas": "DASHBOARD_CHARTS_DRIVERS_RANKING",
    "Veículos em maior circulação": "DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES",
    "Veículos com maior ociosidade": "DASHBOARD_CHARTS_MOST_IDLE_VEHICLES",
    "Uso fora do horário programado": "DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE",
    "Circulação semanal (km)": "DASHBOARD_CHARTS_WEEKLY_CIRCULATION",
    "Limite de velocidade (km)": "DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS",
    "Multas": "DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS", // Ajuste se houver tooltip específico
    
    // English
    "Vehicle Status": "DASHBOARD_CHARTS_VEHICLE_STATUS",
    "Driver Ranking": "DASHBOARD_CHARTS_DRIVERS_RANKING",
    "Most active vehicles": "DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES",
    "Most idle vehicles": "DASHBOARD_CHARTS_MOST_IDLE_VEHICLES",
    "Usage outside scheduled hours": "DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE",
    "Weekly circulation (km)": "DASHBOARD_CHARTS_WEEKLY_CIRCULATION",
    "Speed limit (km)": "DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS",
    "Fines": "DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS",
    
    // Español
    "Estado del vehículo": "DASHBOARD_CHARTS_VEHICLE_STATUS",
    "Ranking de conductores": "DASHBOARD_CHARTS_DRIVERS_RANKING",
    "Vehículos más activos": "DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES",
    "Vehículos con mayor ociosidad": "DASHBOARD_CHARTS_MOST_IDLE_VEHICLES",
    "Uso fuera de horas programadas": "DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE",
    "Circulación semanal (km)": "DASHBOARD_CHARTS_WEEKLY_CIRCULATION",
    "Límite de velocidad (km)": "DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS",
    "Multas": "DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS",
  };
  
  /**
   * Obtém a chave de tooltip baseada no nome do gráfico
   * @param {string} chartName - Nome do gráfico (opt.chart traduzido)
   * @returns {string} - Chave do tooltip ou vazio se não encontrar
   */
  export const getTooltipKeyByChart = (chartName) => {
    return chartTooltipMap[chartName] || "";
  };
  